import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import { ContributorSection } from '../../../components/ContributorSection';
import GenericSection from '../../../components/GenericSection';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { CartoonCitingSection } from '../../../components/citing/CartoonCiting';
import { RecommendationBar } from '../../../components/Shared';
import { CartoonContributorFunctions, MAGAZINE_PUBLICATION_INFO, TabHeaders, TestIds } from '../constants';
import MAGAZINE_PUBINFO_SECTION_FIELDS from '../constants/fieldList/magazineFields';
var MagazineForm = function MagazineForm(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(CartoonCitingSection, {
    selectedTab: TabHeaders.Magazine
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: CartoonContributorFunctions
  }), /*#__PURE__*/React.createElement(GenericSection, {
    name: "pubmagazine",
    sectionTitle: MAGAZINE_PUBLICATION_INFO,
    fieldList: MAGAZINE_PUBINFO_SECTION_FIELDS,
    "data-test": TestIds.CARTOON_MAGAZINE_PUB_INFO_SECTION,
    selectedTab: TabHeaders.Magazine
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default MagazineForm;